import * as Yup from 'yup'


/** Pickup Inbound Receiving schema for Non-Exclusive Seller (have maximum quantity) */
const sellerInboundReceivePickupSchema = Yup.object().shape({
  received_quantity: Yup.number()
    .positive('Must be more than 0')
    .max(50, 'Inbound quantity cannot be more than 50')
    .required('Required'),
  weight      : Yup.number().positive('Must be more than 0').required('Required'),
  tracking_no : Yup.number().positive('Must be positive number').required('Required')
})

export default sellerInboundReceivePickupSchema
